export default __webpack_public_path__ + "static/media/check-inactive.8629fe9c.svg";